import { CrudBaseComponent } from '$core/base/_crud.service';
import { Appeal } from '$core/models/appeal';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MultilangContent } from '$core/models/multilang-content';
import { Pagination } from '$core/models/pagination';
import { Office } from '$modules/pages/post-office/office';

export enum ServiceItemType {
  Help = 'help',
  Meet = 'meet',
  Custom = 'custom',
  Accompany = 'accompany',
  Delivery = 'delivery',
}

export interface AppealServiceItem {
  id: number;
  is_changeable: boolean;
  name: string;
  names: MultilangContent;
  note: string | null;
  type: ServiceItemType;
}

@Injectable({
  providedIn: 'root',
})
export class AppealService extends CrudBaseComponent {
  public apiRoute = '/appeal';
  public MODEL = Appeal;

  public createItem(body) {
    return this.http.post(this.apiRouteWithVersion, body);
  }

  public getServices(): Observable<Pagination<AppealServiceItem>> {
    return this.http.get<Pagination<AppealServiceItem>>(
      this.apiRouteWithVersion + '/services'
    );
  }

  public confirm(body) {
    return this.http.post(`${this.apiRouteWithVersion}/confirmation`, body);
  }

  public getOffice(id: number): Observable<Office> {
    return this.http.get<Office>('/v1/ops/' + id);
  }
}
